import { render, staticRenderFns } from "./PublipostagesUser.vue?vue&type=template&id=5b20e49b&"
import script from "./PublipostagesUser.vue?vue&type=script&lang=js&"
export * from "./PublipostagesUser.vue?vue&type=script&lang=js&"
import style0 from "./PublipostagesUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports